import Handlebars from 'handlebars'
import { HandlebarsPropType } from '../hooks/useHandlebarsContext'
import { titleCased } from './string'

type HandlebarsCompileOptions = Parameters<typeof Handlebars.compile>[1]

Handlebars.registerHelper('lowercased', function (text: string) {
  return text.toLowerCase()
})
Handlebars.registerHelper('titlecased', function (text: string) {
  return titleCased(text)
})

export const insertHandlebarsTemplate = (
  text: string | null | undefined,
  handlebarsContext: HandlebarsPropType,
  handlebarsCompileOptions: HandlebarsCompileOptions = {}
): string | undefined => {
  if (text) {
    const template = Handlebars.compile(text, handlebarsCompileOptions)

    return template(handlebarsContext)
  }

  return undefined
}

export default insertHandlebarsTemplate
